import React, { createContext, useState, useEffect } from "react";
import localforage from "localforage";
import PropTypes from "prop-types";
import { getLanguageData } from "../ui_languages";
import { STORAGE_KEYS } from "../constants/storage";

export const LanguageContext = createContext();

export const LanguageProvider = ({ children }) => {
  const [language, setLanguage] = useState(null);
  const [localizedData, setLocalizedData] = useState(null);
  const [interfaceText, setInterfaceText] = useState(null);

  useEffect(() => {
    localforage
      .getItem(STORAGE_KEYS.SELECTED_LANGUAGE)
      .then((savedLanguage) => {
        if (savedLanguage) {
          setLanguage(savedLanguage);
          loadLocalization(savedLanguage);
        }
      });
  }, []);

  const updateLanguage = async (langKey) => {
    if (langKey === null || langKey === undefined) {
      // await localforage.clear();
      await localforage.removeItem(STORAGE_KEYS.SELECTED_LANGUAGE);
      setLanguage(langKey);
      return;
    }

    await localforage.setItem(STORAGE_KEYS.SELECTED_LANGUAGE, langKey);
    loadLocalization(langKey);
    setLanguage(langKey);
  };

  const loadLocalization = async (langKey) => {
    const interfaceData = getLanguageData(langKey);
    if (interfaceData) {
      setInterfaceText(interfaceData.interface);
    } else {
      console.warn(`Interface localization for ${langKey} not found`);
    }

    try {
      const languagesData = await localforage.getItem(STORAGE_KEYS.LANGUAGES);
      if (languagesData?.[langKey]) {
        setLocalizedData(languagesData[langKey]);
      } else {
        console.warn(`Content localization for ${langKey} not found in cache`);
        setLocalizedData({});
      }
    } catch (error) {
      console.error("Failed to load localization from cache:", error);
      setLocalizedData({});
    }
  };

  return (
    <LanguageContext.Provider
      value={{ language, interfaceText, updateLanguage, localizedData }}
    >
      {children}
    </LanguageContext.Provider>
  );
};

LanguageProvider.propTypes = {
  children: PropTypes.node.isRequired,
};
